import keysToConstants from 'js/lib/keysToConstants';

export const forumLimit = 500;

export const questions = {
  limitsPerPage: {
    peerReview: 15,
    lecture: 5,
    aggregate: 15,
  },
  thought: {
    minChars: 1,
    maxChars: 120,
  },
  details: {
    warnChars: 9850,
    maxChars: 10000,
  },
};

export const answers = {
  limitPerPage: 15,
  thought: {
    warnChars: 9850,
    maxChars: 10000,
  },
};

export const comments = {
  limitPerPage: 15,
};

export const DTD_NAME = 'discussion/1';

export const FluxibleActions = keysToConstants([
  'UPDATE_LOADING_STATE',
  'SEARCH_RESULTS_RECEIVED',
  'SEARCH_PAGE_CHANGE',
  'SEARCH_API_ERROR',
  'CLEAR_DISCUSSIONS_SEARCH_STORE',
]);

export const loadingStates = {
  LOADING: 'LOADING',
  DONE: 'DONE',
  ERROR: 'ERROR',
} as const;

export type LoadingState = (typeof loadingStates)[keyof typeof loadingStates];

export const savingStates = {
  UNCHANGED: 'UNCHANGED',
  UNSAVED_CHANGES: 'UNSAVED_CHANGES',
  SAVING: 'SAVING',
  SAVED: 'SAVED',
  ERROR: 'ERROR',
  INVALID_TERM_ERROR: 'INVALID_TERM_ERROR',
  RATE_LIMIT_ERROR: 'RATE_LIMIT_ERROR',
  USER_BLOCKED_ERROR: 'USER_BLOCKED_ERROR',
  GIBBERISH_ERROR: 'GIBBERISH_ERROR',
} as const;

export type SavingState = (typeof savingStates)[keyof typeof savingStates];

export const answerSorts = {
  oldestSort: 'createdAtAsc',
  popularSort: 'upvotesDesc',
  newestSort: 'createdAtDesc',
} as const;

export type AnswerSort = (typeof answerSorts)[keyof typeof answerSorts];

export const questionSorts = {
  mostRecentSort: 'lastActivityAtDesc',
  popularSort: 'popularityDesc',
  unansweredSort: 'answerCountAsc',
} as const;

export type QuestionSort = (typeof questionSorts)[keyof typeof questionSorts];

export const defaults = {
  detailSort: answerSorts.newestSort,
  detailPage: 1,
  listSort: questionSorts.mostRecentSort,
  listAnswered: undefined,
  listPage: 1,
};
const forumTypeNames = [
  'weekForumType',
  'itemForumType',
  'rootForumType',
  'customForumType',
  'groupForumType',
  'mentorForumType',
  'gradedDiscussionPrompt',
] as const;

// these are provisional, and may change.
export const naptimeForumTypes = keysToConstants([...forumTypeNames]);
export type ForumTypeName = keyof typeof naptimeForumTypes;
// type validation function for ForumTypeName
export function validateForumTypeName(suspectForumTypeName: unknown): suspectForumTypeName is ForumTypeName {
  if (suspectForumTypeName && typeof suspectForumTypeName === 'string' && suspectForumTypeName in naptimeForumTypes) {
    return true;
  }
  return false;
}

export const forumVisibilityTypes = keysToConstants(['ALWAYS_VISIBLE', 'ALWAYS_HIDDEN']);
export const gradedDiscussionPromptTypes = keysToConstants(['allPosts', 'mySubmissionsOnly']);
export const forumAnswerBadgeTagType = 'HIGHLIGHTED';

export const defaultPageSize = 15;
